import { render, staticRenderFns } from "./FileInputMultiple.vue?vue&type=template&id=154b5bfb&"
import script from "./FileInputMultiple.vue?vue&type=script&lang=js&"
export * from "./FileInputMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports